import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useMutation } from '@apollo/client';
import { CREATE_PARTNER_CLIENT_ACCOUNT } from '../../../../actions/create';
import { toast } from 'react-toastify';
import Preloader from '../../../global/Preloader';
import {Box, ButtonV2, InputV2, Modal} from "@/elements";

const ModalCreateAccount = ({ show, hideModal, query, getVariables, partnerAccountId }) => {
  const validationSchema = Yup.object().shape({
    name: Yup.string().test('required', 'Field is required', function (item) {
      return this.parent.name.replaceAll(' ', '').length;
    }),
  });

  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const [setCreateAccount, { loading }] = useMutation(CREATE_PARTNER_CLIENT_ACCOUNT);

  const onSubmit = (dataInput) => {
    setCreateAccount({
      variables: {
        partnerAccountId,
        name: dataInput.name,
      },
      refetchQueries: [{ query: query, variables: getVariables() }],
    })
      .then(() => toast.success('Success'))
      .catch((err) => toast.error(err.message));
    hideModal();

  };

  if (loading) return <Preloader />;

  return (
    <Modal
      enableMaximize={false}
      width="400px"
      title={"Create new account"}
      toggle={() => hideModal()}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Box justify={'center'} width="100%">
          <Controller
            name="name"
            control={control}
            defaultValue=""
            render={({ field: { onChange, value } }) => (
              <InputV2
                onChange={onChange}
                value={value}
                label="Name"
                width="100%"
                error={!!errors.name}
                helperText={errors?.name?.message ?? ' '}
              />
            )}
          />
        </Box>

        <Box direction="column" gap="16px" margin="8px 0">
          <Box width="100%" align="center" gap="16px" justify="right">
            <ButtonV2 variant="greenSmoke" onClick={() => hideModal()}>
              Cancel
            </ButtonV2>
            <ButtonV2 type="submit">
              CREATE
            </ButtonV2>
          </Box>
        </Box>
      </form>
    </Modal>
  );
};

export default ModalCreateAccount;
